import { FunctionComponent, useState } from 'react';
import { Button, Div, BodyText, Title, Gutter, Flex, Icon } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { RootState } from '../../../store/reducers';
import { authSetUserInfo, executeLogout } from '../../../store/actions';
import { userAcceptCompanyDevicePolicy } from '../../../utils';

const CompanyDevicePolicy: FunctionComponent = () => {
  const [loading, setLoading] = useState(false);
  const user = useSelector((state: RootState) => state.authentication.user);

  const dispatch = useDispatch();
  const history = useHistory();

  const { t } = useTranslation('authentication');

  const handleRedirectToCompanyDevicePolicy = () => {
    globalThis.open(user?.organization?.company_device_policy_url ?? '', '_blank');
  };

  const handleUserAcceptsCompanyDevicePolicy = async () => {
    setLoading(true);
    const user = await userAcceptCompanyDevicePolicy();
    if (!user) {
      history.push('/authentication/logout');
      dispatch(executeLogout());
      return;
    }

    dispatch(authSetUserInfo(user));
    history.push('/home');
  };

  const handleLogout = () => {
    dispatch(executeLogout());
  };

  return (
    <Div padding={{ top: 'xxlg', horizontal: 'xxlg' }}>
      <Title size="md" color="gray800" block uppercase>
        {t('CompanyDevicePolicy.companyDevicePolicy')}
      </Title>
      <Gutter size="lg" />
      <BodyText color="gray800" block>
        {`${t('CompanyDevicePolicy.infoText')}`}
      </BodyText>
      <Gutter size="sm" />

      {!!user?.organization?.name && (
        <>
          <Flex color="purple500">
            <BodyText tagName="a" clickableAppearance onClick={handleRedirectToCompanyDevicePolicy}>
              {`${user.organization.name} - ${t('CompanyDevicePolicy.companyDevicePolicy')}`}
            </BodyText>
            <Icon tagName="a" margin={{ left: 'xxs' }} name="external" size="md" clickableAppearance onClick={handleRedirectToCompanyDevicePolicy} />
          </Flex>
          <Gutter size="layout-7" />
          <Button inlineBlock variant="primary" size="lg" onClick={handleUserAcceptsCompanyDevicePolicy} loading={loading}>
            {t('CompanyDevicePolicy.acceptButton')}
          </Button>
          <Gutter inlineBlock />
          <Button inlineBlock variant="secondary" size="lg" onClick={handleLogout}>
            {t('CompanyDevicePolicy.logoutButton')}
          </Button>
        </>
      )}
    </Div>
  );
};

export default CompanyDevicePolicy;
